import dayjs from 'dayjs';

export default {
    data: () => ({
        now: dayjs(),
    }),
    methods: {
        transform(props) {
            Object.entries(props).forEach(([key, value]) => {
                const digits = value < 10 ? `0${value}` : value;
                props[key] = `${digits}`;
            });

            return props;
        },
        checkBeforeNowDate(date) {
            return dayjs(date).isBefore(this.now);
        },
        textFormat(str) {
            return str.replace(/([^>])\n/g, '$1<br/>');
        }
    }
};
